namespace Core {

    class AgentNetInfo {

        data:any;
        displayToolTip:boolean = false;
        currency:string = TRPCONFIG.Domain.CurrencyCode;
        areas = {
            Holidays : 'holidays',
            Hotels: 'hotels',
            Flights: 'flights'
        };
        netValues:NetValues;
        enabled:boolean = false;
        mode:string;
        vat:number;
        markdown:{ OriginalPrice: Number, MarkdownAmount: Number};

        constructor(private $scope:ng.IScope, private $q:ng.IQService,
            private $route, private $routeParams, private agentNetInfoService) {
            const area = this.$route.current.area;
            this.enabled = false;
            const enabledAreas = TRPCONFIG.Domain.AgentNetInfoEnabledAreas.split(',');
            const areaIsEnabled = enabledAreas.length && enabledAreas.some( item => {
                return item === area;
            });
            if(areaIsEnabled) {
                this.createToolTip().then( data => {
                    this.enabled = true;
                    this.populateToolTip();
                }, data => {
                    this.enabled = false;
                });
            }
        }

        createToolTip(){
            var deferred = this.$q.defer();
            if(this.data) {
                const isValidData = this.agentNetInfoService.hasRequiredValues(this.data, this.mode);
                isValidData ? deferred.resolve( this.data ) : deferred.reject( this.data );
            } else {
                const dataLoaded = this.$scope.$watch('ani.data', (value, prev)=> {
                    if (this.agentNetInfoService.hasRequiredValues(value, this.mode)){
                        dataLoaded();
                        deferred.resolve( this.data );
                    } else {
                        deferred.reject( this.data );
                    }
                });
            }
            return deferred.promise;
        }

        populateToolTip(){
            this.netValues = this.populateNetValues();
        }

        showToolTip() {
            this.displayToolTip = !this.displayToolTip;
        }

        populateNetValues() {
            if(this.$route.current.area === this.areas.Hotels) {
                this.data = this.data.concat(
                    [
                        { Cost : { Value : this.vat, CurrencyCode : TRPCONFIG.Domain.CurrencyCode}, Type : 0 },
                        { ...this.markdown, Type: 99 }
                    ]);
            }
            return this.agentNetInfoService.parse(this.data, this.mode);
        }

    }

    class AgentNetInfoHotels {
        data: any;
        displayToolTip: boolean = false;
        enabled: boolean = false;
        netValues:NetValues;

        constructor(private $scope: ng.IScope, private agentNetInfoService) {
            this.enabled = this.agentNetInfoService.hasRequiredValues(this.data, 'hotelinfo');
            if(this.enabled){
                this.netValues = this.populateNetValues();
            }
        }

        populateNetValues() {
            return this.agentNetInfoService.parse(this.data, 'hotelinfo');
        }

        showToolTip() {
            this.displayToolTip = !this.displayToolTip;
        }
    }

    angular
        .module('core')
        .directive('agentNetInfo', (): ng.IDirective => {
            return {
                restrict : 'E',
                scope: {},
                controller: AgentNetInfo,
                controllerAs: 'ani',
                bindToController: {
                    data: '=',
                    mode: '@',
                    showTaxes: '=',
                    vat: '=',
                    markdown: '='
                },
                template: `<div class="question-mark-red"
                ng-mouseenter="ani.showToolTip()"
                ng-mouseleave="ani.showToolTip()" ng-show="ani.enabled">
                    <div class="ui-tooltip" ng-show="ani.displayToolTip">
                        <agent-net-info-table data="ani.netValues" show-tax="ani.showTaxes"
                        commission-type="{{ani.netValues.CommissionType}}" mode="{{ani.mode}}"></agent-net-info-table>
                    </div>
                </div>`
            };
        })
        .directive('agentNetInfoHotels', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                controller: AgentNetInfoHotels,
                controllerAs: 'anih',
                bindToController: {
                    data: '='
                },
                template: `<div class="question-mark-red"
                ng-mouseenter="anih.showToolTip()"
                ng-mouseleave="anih.showToolTip()" ng-show="anih.enabled">
                 <div class="ui-tooltip" ng-show="anih.displayToolTip">
                        <agent-net-info-table data="anih.netValues" mode="hotel"></agent-net-info-table>
                    </div>
                </div>`
            };
        });
};
